<template>
    <div :class="$style['mobile-filter-container']">
        <div ::class="$style['top-row']">
            <div :class="$style['first-top-row']">
                <div :class="$style['close-container']">
                    <button
                        type="button"
                        class="close-product-filter-btn"
                        @click="toggleOpen()"
                        aria-label="Close"
                    ></button>
                </div>
                <div :class="$style['logo-container']">
                    <img
                        :src="logoImage"
                        style="width: 130px"
                        loading="lazy"
                        width="130"
                        height="23"
                        alt="Odendo"
                    />
                </div>
                <div :class="$style['empty-container']"></div>
            </div>

            <div :class="$style['tab-selector']">
                <div
                    :class="[
                        $style['tab'],
                        tab == 'filter' ? $style['current-tab'] : '',
                    ]"
                    @click="tab = 'filter'"
                >
                    {{ labels.frontendProductList.filters.tabs.filters }}
                </div>
                <div
                    :class="[
                        $style['tab'],
                        tab == 'sorting' ? $style['current-tab'] : '',
                    ]"
                    @click="tab = 'sorting'"
                >
                    {{ labels.frontendProductList.filters.tabs.sortings }}
                </div>
            </div>
        </div>

        <div :class="$style['tab-content']">
            <div v-show="tab == 'filter'">
                <div ref="filterContainer"></div>
            </div>
            <div v-show="tab == 'sorting'">
                <div ref="sortingContainer"></div>
            </div>
        </div>
    </div>
</template>

<style module>
.logo-container {
    text-align: center;
}

.close-container,
.logo-container,
.empty-container {
    flex: 1;
}

.top-row {
    background-color: #f9f9f9;
}

.first-top-row {
    display: flex;
    flex-direction: row;
}

.mobile-filter-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    padding: 15px;
}

.tab-selector {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.tab {
    padding-top: 15px;
    padding-bottom: 15px;
    flex: 1;
    text-align: center;
    position: relative;
}

.tab:after {
    display: block;
    content: "";
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 8px;
    background-color: rgba(0, 0, 0, 0);
    transition: all 0.4s;
}

.tab.current-tab:after {
    background-color: #272727;
}

.tab-content {
    flex: 1;
    overflow-y: scroll;
    padding-top: 10px;
}

.currently-open {
    overflow: hidden;
}
</style>

<script lang="ts">
import { default as logoUrl } from "../../header/top-site/logo.png";
import labels from "../../shared/labels";

export default {
    data() {
        return {
            logoImage: logoUrl,
            hasSortingComponent: false,
            tab: "filter",
            mutationObserver: new MutationObserver((mutationList, observer) =>
                (this as any).parentMutation(mutationList, observer)
            ),
            labels,
        };
    },
    methods: {
        toggleOpen() {
            this.setOpen(!this.isOpen());
        },
        setOpen(value: boolean) {
            const filterElement = window.$(this.getFilterElement());
            const $body = window.$(document.body);
            if (value == true) {
                // open
                filterElement.addClass("open");
                $body.addClass((this as any).$style["currently-open"]);
            } else {
                // close
                filterElement.removeClass("open");
                $body.removeClass((this as any).$style["currently-open"]);
            }
        },
        isOpen() {
            const filterElement = window.$(this.getFilterElement());
            return filterElement.hasClass("open");
        },
        getFilterElement() {
            if (this.$el.parentElement == null)
                throw new Error("missing parent el");
            return this.$el.parentElement;
        },
        moveAllElements() {
            const filterEl = this.getFilterElement();
            for (const childElement of Array.from(filterEl.children)) {
                if (childElement === this.$el) continue;
                if (childElement.hasAttribute("data-keep-in-form")) continue;

                if (childElement.hasAttribute("data-sorting-component")) {
                    (this.$refs.sortingContainer as HTMLElement)?.appendChild(
                        childElement
                    );
                    this.hasSortingComponent = true;
                } else {
                    (this.$refs.filterContainer as HTMLElement)?.appendChild(
                        childElement
                    );
                }
            }
        },
        parentMutation(mutationList: MutationRecord[]) {
            const addedNodes = mutationList.reduce((prev, curr) => {
                for (const addedNode of Array.from(curr.addedNodes)) {
                    prev.push(addedNode);
                }
                return prev;
            }, [] as Node[]);

            if (addedNodes.length > 0) this.moveAllElements();
        },
    },
    mounted() {
        this.moveAllElements();
        this.mutationObserver.observe(this.getFilterElement(), {
            attributes: false,
            childList: true,
            subtree: false,
        });
        window
            .$(this.getFilterElement())
            .data("toggleOpen", () => this.toggleOpen());
        window
            .$(this.getFilterElement())
            .data("setOpen", (v: boolean) => this.setOpen(v));
    },
};
</script>
